import { useQuery } from "@tanstack/react-query";

import { QuerySessionStatsRequestDto } from "@/shared/api";
import { useApi } from "@/shared/api/use-api";

type Params = {
  userId?: number;
  sessionId?: string;
  pageNumber: number;
  pageSize: number;
  filters: QuerySessionStatsRequestDto;
};

export const useGetSessionStats = ({
  userId,
  sessionId,
  pageNumber,
  pageSize,
  filters,
}: Params) => {
  const { statsControllerApi } = useApi();

  return useQuery({
    queryKey: [`getSessionStats`, userId, sessionId, pageNumber, pageSize, filters],
    queryFn: ({ signal }) => {
      return statsControllerApi.querySessionStats(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        userId!,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        sessionId!,
        pageNumber,
        pageSize,
        filters,
        {
          signal,
        }
      );
    },
    enabled: !!sessionId && !!userId,
    retry: 0,
  });
};
